angular.module('app.controllers.alerts', [])
  .controller('AlertsController', ['$scope', '$log', function ($scope, $log) {

  'use strict';

  $log.debug('AlertsController()');

  // iniitialize
  $scope.alertVisible = true;

  $scope.closeAlert = function(index) {
    $scope.alertVisible = false;
  };

  $scope.hideAlert = function() {
    $scope.alertVisible = false;
  };

}]);
